import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    imgHref: {
      borderRadius: 'inherit',
    },
    img: {
      borderRadius: 'inherit',
    },
  }
})
